var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.019,
    height: 17.02,
    viewBox: "0 0 17.019 17.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_992",
    "data-name": "Group 992",
    transform: "translate(-1241 -217.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-edit",
    "data-name": "Icon feather-edit",
    transform: "translate(1241.5 218)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_625",
    "data-name": "Path 625",
    d: "M15.738,20.831H4.592A2.1,2.1,0,0,1,2.5,18.738V7.592A2.1,2.1,0,0,1,4.592,5.5h5.573a.5.5,0,1,1,0,1H4.592A1.094,1.094,0,0,0,3.5,7.592V18.738a1.094,1.094,0,0,0,1.092,1.092H15.738a1.094,1.094,0,0,0,1.092-1.092V13.165a.5.5,0,0,1,1,0v5.573A2.1,2.1,0,0,1,15.738,20.831Z",
    transform: "translate(-3 -4.311)",
    fill: "#102250"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_626",
    "data-name": "Path 626",
    d: "M21.554,2.318A2.189,2.189,0,0,1,23.1,6.055l-7.563,7.563a.5.5,0,0,1-.232.132l-3.185.8a.5.5,0,0,1-.606-.606l.8-3.185a.5.5,0,0,1,.132-.232l7.563-7.563A2.175,2.175,0,0,1,21.554,2.318Zm-6.625,10.5,7.466-7.466a1.189,1.189,0,0,0-1.681-1.681l-7.466,7.466-.56,2.242Z",
    transform: "translate(-7.223 -2.818)",
    fill: "#102250"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.0c69d1bfc81c37befa57b06bb0e2df18.svg";
export { ForwardRef as ReactComponent };